import { globalEnvironment } from './global';
import {MODULES} from './module.config';
import {BASE_URL} from './commons/base-url';
import {ALLEANZA_COMMON_ENV} from './commons/dias-alleanza';
import { GLOBAL_CONFIG } from 'src/app/configs/global.config';

export const environment = {
  production: false,
  ...globalEnvironment,
  ...BASE_URL,
  ...ALLEANZA_COMMON_ENV,
  ...GLOBAL_CONFIG,
  routes: [
    MODULES.homepage.route,
    MODULES['MarketShares'].route,
    MODULES['Invoices'].route,
    MODULES['AuditCreation'].route,
    MODULES['AuditComplete'].route,
  ],
  b2cPolicies: {
    clientId: 'b24a83f7-a020-4b37-acab-f1a7d9d5a9a3',
    tenantId: 'c7788286-49f4-40db-bf26-fc1c677df787',
    redirectUri: 'https://alleanza-dev.cube.rina.org/',
    redirectCourtesyPageUri: 'https://www.rina.org/',
    postLogoutRedirectUri: 'https://www.rina.org/',
    tenant: 'rinagroupb2cdevl',
    names: {
      signUpSignIn: 'B2C_1A_SIGNUP_SIGNIN',
      resetPassword: 'B2C_1A_PASSWORDRESET',
    },
    authorities: {
      signUpSignIn: {
        authority: 'https://test-login.rina.org/rinagroupb2cdevl.onmicrosoft.com/B2C_1A_SIGNUP_SIGNIN',
      },
      resetPassword: {
        authority: 'https://test-login.rina.org/rinagroupb2cdevl.onmicrosoft.com/B2C_1A_PASSWORDRESET',
      },
      editProfile: {
        authority: 'https://test-login.rina.org/rinagroupb2cdevl.onmicrosoft.com/B2C_1A_PROFILEEDIT',
      },
    },
    domain: 'https://test-login.rina.org/',
    subdomain: 'rinagroupb2cdevl.onmicrosoft.com',
    authorityDomain: 'https://test-login.rina.org/rinagroupb2cdevl.onmicrosoft.com',
  },
  localStorageKeyPrefix: 'cube-alleanza-dev',
};
